export default __webpack_public_path__ + "static/media/homeImage4.03ba21c3.jpeg";